<script>
import SpinnerIndicator from "@js/components/Sections/Statuses/SpinnerIndicator.vue";
import {Link} from "@inertiajs/vue3";
import default_img from "@img/defaults/product-not-found.webp";
import NumberFormatComponent from "@js/components/Formatter/NumberFormatComponent.vue";

export default {
    name: "CatalogProductItem",
    components: {NumberFormatComponent, SpinnerIndicator, Link},
    props: {
        data: {
            required: true,
            type: Object,
        }
    },
    data() {
        return {
            imageLoaded: false,
        }
    },
    methods: {
        onImageLoad() {
            this.imageLoaded = true;
        },
        replaceByDefaultImg(event) {
            event.target.src = '/assets/images/defaults/product-not-found.webp'; // Replace with your default image path
        },
    },
    setup() {
        return {default_img}
    }
}
</script>

<template>
    <Link class="relative" :href="route('product.show', { path: data.full_path })">
        <div
            class="h-full bg-white shadow border border-gray-200 md:hover:border-indigo-600 rounded-xl transition cursor-pointer">
            <div class="relative overflow-hidden rounded-xl flex flex-col z-1 shadow-sm bg-white">
                <div class="block w-full h-[175px]">
                    <div v-if="data.bestseller" class="absolute right-0">
                        <div class="font-bold text-[11px] text-white px-3 py-0.5 rounded-bl-md bg-[#c52314] leading-5">
                            ХИТ
                        </div>
                    </div>
                    <img :src="data.image !== null ? '/storage/products/' + data.image.path + '/cover/' + data.image.order[0] : default_img"
                         class="w-full h-full object-cover"
                         :class="imageLoaded ? '' : 'img-loading'"
                         :alt="data.name ?? 'Продукт'"
                         :title="data.name ?? 'Продукт'"
                         @load="onImageLoad"
                         @error="replaceByDefaultImg"
                    />
                    <div v-if="!imageLoaded" class="flex flex-wrap items-center justify-center h-full">
                        <SpinnerIndicator class="w-10 h-10 ms-2"/>
                    </div>
                </div>
            </div>
            <div class="p-4">
                <div class="font-bold text-base text-indigo-600 md:hover:text-indigo-800 transition cursor-pointer">
                    {{ data.name ?? '' }}
                </div>
                <div class="flex items-center justify-between">
                    <template v-if="data.price">
                        <div class="font-bold text-lg">
                            <NumberFormatComponent :number="data.price" append_text=" ₽"/>
                        </div>
                    </template>
                    <template v-else>
                        <div class="font-bold">
                            Цена Договорная
                        </div>
                    </template>
                    <div :class="[data.availability ? 'bg-emerald-700' : 'bg-red-600']"
                         class="font-semibold text-[11px] text-white px-2 py-0.5 rounded-full">
                        {{ data.availability ? 'В наличии' : 'Нет в наличии' }}
                    </div>
                </div>
                <hr class="mt-1 mb-1"/>
                <div v-if="data.length"
                     class="flex justify-between w-full text-xs font-medium md:hover:text-indigo-600 transition">
                    <div>
                        Длина
                    </div>
                    <div>
                        <NumberFormatComponent :number="data.length" append_text=" мм."/>
                    </div>
                </div>
                <div v-if="data.width"
                     class="flex justify-between w-full text-xs font-medium md:hover:text-indigo-600 transition">
                    <div>
                        Ширина
                    </div>
                    <div>
                        <NumberFormatComponent :number="data.width" append_text=" мм."/>
                    </div>
                </div>
                <div v-if="data.height"
                     class="flex justify-between w-full text-xs font-medium md:hover:text-indigo-600 transition">
                    <div>
                        Высота
                    </div>
                    <div>
                        <NumberFormatComponent :number="data.height" append_text=" мм."/>
                    </div>
                </div>
                <div v-if="data.weight"
                     class="flex justify-between w-full text-xs font-medium md:hover:text-indigo-600 transition">
                    <div>
                        Вес
                    </div>
                    <div>
                        <NumberFormatComponent :number="data.weight" append_text=" т."/>
                    </div>
                </div>
<!--                <hr class="mt-2 mb-2"/>-->
<!--                <div class="flex items-center justify-between">-->
<!--                    <button type="button"-->
<!--                            class="px-3 py-2 text-xs font-medium text-center text-white bg-indigo-700 rounded-lg hover:bg-indigo-800 focus:ring-4 focus:outline-none focus:ring-indigo-300 dark:bg-indigo-600 dark:hover:bg-indigo-700 dark:focus:ring-indigo-800">-->
<!--                        В корзину-->
<!--                    </button>-->
<!--                    <button type="button"-->
<!--                            class="px-3 py-2 text-xs font-medium text-center text-white bg-indigo-700 rounded-lg hover:bg-indigo-800 focus:ring-4 focus:outline-none focus:ring-indigo-300 dark:bg-indigo-600 dark:hover:bg-indigo-700 dark:focus:ring-indigo-800">-->
<!--                        Подробнее-->
<!--                    </button>-->
<!--                </div>-->
            </div>
        </div>
    </Link>
</template>

<style scoped lang="scss">
.z-1 {
    z-index: 1;
}

.img-loading {
    max-width: 0 !important;
    max-height: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
    position: absolute !important;
}
</style>
